import React from "react";
import { Grid, Header, Image, Segment } from "semantic-ui-react";
import styles from './OverviewModuleDescription.module.css';

const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const LegalModuleDescription: React.FC = () => {
  return (
    <Segment basic id={styles['medicalOverview']}>
      <p className={styles.overviewText} >
        The legal and financial issues associated with the care of older adults
        can be extremely complex. The purpose of this section is to identify and
        describe common legal and financial tasks to help plan for the future of
        the older adult.
      </p>
      <p className={styles.overviewText} >
      Early and thoughtful planning can minimize unplanned barriers, such as the onset of dementia or a stroke, from causing issues in the future such as financial exploitation or unintentional dissipation of assets. This will also help to ensure the wishes of the older adult are addressed and carried out as planned. It may be helpful to complete these tasks with an elder law attorney and possibly a financial planner familiar with late-life issues, and accountant, and/or a geriatric care manager.
      </p>
            
      <Segment raised className={styles.segmentObjectives}>   
        <Header className={styles.objectivesGroupHeader} >Objectives </Header>     
        <Grid stackable>
          <Grid.Row columns='equal' stretched className={styles.objectivesItemRow} >
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColLeft}`} >
              <Segment raised className={styles.objectivesItemWhiteBG} >  
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}IdentifyIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >IDENTIFY</p>
                  </Segment> 
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    Identify and describe common legal and financial tasks associated with care of aging loved ones. 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColMiddle}`} >
              <Segment raised className={styles.objectivesItemWhiteBG} >  
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}ProvideLegalIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >PROVIDE</p>
                  </Segment> 
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                     Provide specific resources in helping families and caregivers complete those tasks 
                    considered most important by the recipient.
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColRight} `}>
              <Segment raised className={styles.objectivesItemWhiteBG} >  
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}ReviewIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >REVIEW</p>
                  </Segment> 
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    To perform a comprehensive review of financial, insurance, and legal documents to 
                    respect the wishes of the older adult. 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </Segment>
  );
};

export default LegalModuleDescription;
